<template>
  <section class="flex level-1" v-touch:swipe.right="swipeRightHandler">
  
  
  
    <!-- CONTENT-->
    <div class="content">
        <!-- //TITLE MOBILE -->
      <div class="mobile"  :class="{isMobile:isMobile}">

        <div class="link">
          <button class="bt btn-back" @click="goBack()">
            <font-awesome-icon :icon="['far', 'angle-left']"/>
          </button>
          <h2><span class="fas fa-chart-bar"></span>Production</h2>
        </div>
        <div class="sep"></div>
      </div>
        <!-- //TITLE MOBILE -->


      <div class="desktop">
        <h2><span class="fas fa-chart-bar"></span>Production</h2>
      </div>

      <!-- TABS -->
      <b-tabs content-class="mt-3" :class="{isMobile:isMobile}">
        <b-tab title="Nombre" active>
          <b-row>
            <b-col sm="12" lg="6" v-for="content in contents" :key="content.id">
              <cardSmall 
              :title = content.title
              :link = content.id
              :parent = $route.params.who
              :number = content.number
              :resultOne = content.resultOne
              :resultTwo = content.resultTwo
              :date = content.date
              :dateTwo = content.dateTwo
              :chart = content.chart
              />
            </b-col>    
          </b-row>
        </b-tab>

        <b-tab title="Montant">
          <p>I'm the second tab</p>
        </b-tab>

        <b-tab title="%UC">
          <p>I'm a disabled tab!</p>
        </b-tab>
      </b-tabs>
      <!-- TABS -->

    </div>
    <!-- CONTENT-->
  </section>
</template>


<script>
import cardSmall from '../../../module/card/CardSmall'
import { mapGetters } from 'vuex'
import utils from '../../../Utils'


export default {
  name:"life",

  components:{
    cardSmall
  },  
  data () {
      return {
        contents: [],
        isMobile:false,
      }
  },
  computed: {
    ...mapGetters([
      'getProductionCardSmall',
      'getScrollTop'
    ])
  },
  created : function (){
    this.contents = this.getProductionCardSmall;
    this.isMobile = utils.isMobile();
  },
  mounted(){
  },
  methods:{
    goBack() {
      this.$store.dispatch('goBack')
      this.$router.push({name: "browseHome"});
      // this.$router.push({path: "/admin/me/parcourir"});
    },
    swipeRightHandler () {
        this.goBack();
    },                    
  }

};
</script>
